import { getAxiosConfig } from "@/services/axiosConfig";
import { ENDPOINTS } from "@/api/routing";

import { IUserPlanInfo } from "@/types/billing.types";
import {
  IPlansPaylink,
  IRequestSubscribeParam,
  IRequestUuidParam,
  WithData,
} from "@/types/all.types";
import {
  BillingTypeEnum,
  IBillingTax,
  IUserBillingInfo,
  ValidatePostalCodeType,
} from "@/components/page-modules/checkout/data/checkout.type";

const payment = {
  postPaymentUpgrade: async () => {
    const res = await getAxiosConfig().post<IPlansPaylink>(ENDPOINTS.UPDATE_PAYMENT());
    return res.data;
  },
  postCancelSubscribe: async (params: Record<string, any> | undefined) => {
    const res = await getAxiosConfig().post(ENDPOINTS.CANCEL_SUBSCRIPTION(), params);
    return res.data;
  },
  postReactivateWithDiscount: async () => {
    const res = await getAxiosConfig().post(ENDPOINTS.POST_REACTIVATE_WITH_DISCOUNT());
    return res.data;
  },
  getReactivateSubsScription: async () => {
    const res = await getAxiosConfig().post(ENDPOINTS.GET_REACTIVATE_SUBSSCRIPTION());
    return res.data;
  },
  applyDiscount: async () => {
    const res = await getAxiosConfig().post(ENDPOINTS.APPLY_DISCOUNT());
    return res.data;
  },
};

const checkout = {
  createPaymentMethods: async () => {
    const res = await getAxiosConfig().post(ENDPOINTS.CREATE_PAYMENT_METHODS());
    return res.data;
  },
  getPaymentMethods: async () => {
    const res = await getAxiosConfig().get(ENDPOINTS.CREATE_PAYMENT_METHODS());
    return res.data;
  },

  showUserPlan: async ({
    uuid,
    billingType,
    state,
    country,
    withPostalCode,
    postalCode,
  }: {
    uuid: string;
    billingType: BillingTypeEnum | null;
    state?: string;
    country?: string;
    withPostalCode?: boolean;
    postalCode?: string;
  }) => {
    const res = await getAxiosConfig().get<WithData<IUserBillingInfo>>(
      ENDPOINTS.SHOW_USER_PLAN({
        uuid,
        isCompany: billingType ? billingType === BillingTypeEnum.COMPANY : null,
        state,
        country,
        withPostalCode,
        postalCode,
      }),
    );
    return res.data;
  },

  validatePostalCode: async (planUuid: string, payload: ValidatePostalCodeType) => {
    const res = await getAxiosConfig().post<ValidatePostalCodeType, WithData<{ success: boolean }>>(
      ENDPOINTS.VALIDATE_POSTAL_CODE(planUuid),
      payload,
    );
    return res.data;
  },

  validateVat: async (payload: IBillingTax) => {
    const res = await getAxiosConfig().post<IBillingTax, WithData<{ valid: boolean }>>(
      ENDPOINTS.VALIDATE_VAT(),
      payload,
    );
    return res.data;
  },

  // will removed
  showUserPlans: async (params: { queryKey: string[] }) => {
    const uuid = params.queryKey[1];
    const res = await getAxiosConfig().get<IUserPlanInfo>(ENDPOINTS.SHOW_USER_PLANS(uuid));
    return res.data;
  },

  subscribe: async (params: IRequestSubscribeParam, bypassPreCondition: boolean) => {
    const res = await getAxiosConfig().post(
      ENDPOINTS.POST_SUBSCRIBE(params.uuid, bypassPreCondition),
      params,
    );
    return res.data;
  },

  subscribeFreemium: async (param: IRequestUuidParam) => {
    const res = await getAxiosConfig().post(ENDPOINTS.POST_SUBSCRIBE_FREEMIUM(param.uuid));
    return res.data;
  },
};

export { payment, checkout };
